import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useSelector } from "react-redux";

const Index = ({ children }) => {
    const component = useSelector(state => state?.component)
    return (
        <React.Fragment>
            <Header />
            <Sidebar />
            <div className={`content-panel ${component?.sideBar ? "content-panel-lg" : "content-panel-sm"} `} ><div className="container-fluid">{children}</div></div>
        </React.Fragment>
    );
};

export default Index;
